import { Suspense, useId, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { LoadingScreen } from '../components/feedback/LoadingScreen';

// Responsive application layout foundation: fixed sidebar on md+, collapsible off-canvas
// on small screens, scrollable content region hosting the routed outlet.
export function AppShell(): JSX.Element {
  const [navOpen, setNavOpen] = useState(false);
  // Single source of truth for the id linking the hamburger's aria-controls to the panel it
  // toggles — generated once here and passed explicitly to both, never duplicated as a literal.
  const navId = useId();
  const hamburgerRef = useRef<HTMLButtonElement>(null);

  // One close path for every dismissal (backdrop, Escape, link activation) — always restores
  // focus to the trigger, so it never lands on a hidden/removed element. No-op on desktop,
  // where the trigger is itself hidden (md:hidden) and therefore not focusable.
  const closeNav = (): void => {
    setNavOpen(false);
    hamburgerRef.current?.focus();
  };

  return (
    <div className="flex h-full w-full">
      <Sidebar open={navOpen} navId={navId} onClose={closeNav} />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar navOpen={navOpen} navId={navId} hamburgerRef={hamburgerRef} onToggleNav={() => setNavOpen((prev) => !prev)} />
        <main className="min-h-0 flex-1 overflow-auto p-4">
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
